import config from "./config/user";
import axios from "@/utils/request";

export const login = options => axios.post(config.login, options);
export const messageList = options => axios.post(config.user_message_list, options);
export const userMessageListNew = options => axios.post(config.user_message_list_new, options);
export const markSomeMessage = options => axios.post(config.mark_some_message, options);
export const markAllMessage = options => axios.post(config.mark_all_message, options);
export const showUserMessage = options => axios.post(config.show_user_message, options);
export const userInfo = options => axios.get(config.userinfo, options);
//手机号+登录密码登录
export const phonelogin = options => axios.post(config.phonelogin,options);
//身份证登录
export const idcardlogin = options => axios.post(config.idcardlogin,options);
//验证码登录
export const codelogin = options => axios.post(config.codelogin,options);
//发送验证码
export const sendcode = options => axios.post1(config.sendcode,options);

//管理员和**登录
export const loginname = options => axios.post(config.loginname,options);
export const login_acount_password = options => axios.post(config.login_acount_password,options);
export const getVerifyInfo = options => axios.post(config.getVerifyInfo,options);


//手机号+登录密码登录
export const login_phone_password = options => axios.post(config.login_phone_password,options);
//身份证登录
export const login_idcard_password = options => axios.post(config.login_idcard_password,options);
//验证码登录
export const login_sms = options => axios.post(config.login_sms,options);

//万能
export const setSystemData = options => axios.post(config.set_system_data, options);
export const getSystemData = options => axios.get(config.get_system_data, options);
export const setSystemConfig = options => axios.post(config.set_system_config, options);



// 角色管理新接口
export const newRuleAdd = options => axios.post(config.newRuleAdd, options);
export const newRuleEdit = options => axios.post(config.newRuleEdit, options);
export const newRuleList = options => axios.get(config.newRuleList, options);
export const newRoleList = options => axios.get(config.newRoleList, options);
export const newRuleDelete = options => axios.post(config.newRuleDelete, options);
export const newGetSystemData = options => axios.post(config.get_system_data_new, options);
export const newGetSystemCode = options => axios.post1(config.get_system_code_new, options);
export const newRuleView = options => axios.post(config.newRuleView, options);
export const getAllMenu = options => axios.get(config.getAllMenu, options);
export const getMenu = options => axios.get(config.getMenu, options);
export const updateMenu = options => axios.post(config.updateMenu, options);
export const menuAdd = options => axios.post(config.menuAdd, options);
export const menuEdit = options => axios.post(config.menuEdit, options);
export const menuDelete = options => axios.post(config.menuDelete, options);
